import React from "react";
import { Helmet } from "react-helmet-async";
import './terms.css';

const Terms = () => {
  return (
    <div className="sr-terms">
      <Helmet>
        <title>Community Guidelines - SastiRide</title>
        <meta name="description" content="Community guidelines and terms of service for using the SastiRide ride-sharing platform in Pakistan." />
        <link rel="canonical" href="https://sastiride.com/terms" />
      </Helmet>
      <div className="sr-terms__top">
        <h1 className="sr-terms__title">Community Guidelines</h1>
        <p className="sr-terms__subtitle">How we ride together — updated April 2026</p>
      </div>

      <div className="sr-terms__body">
        <div className="sr-terms__content">
          <div className="sr-terms__section">
            <h2>1. Welcome to the Community</h2>
            <p>SastiRide is built by and for people who believe in sharing rides, saving money, and reducing traffic together. By joining us, you're agreeing to follow these simple guidelines that keep our community safe and friendly for everyone.</p>
          </div>

          <div className="sr-terms__section">
            <h2>2. What We're About</h2>
            <p>We're a community-driven platform that helps drivers with empty seats connect with passengers heading the same way. We don't run a taxi service — we simply bring people together so everyone can travel smarter, cheaper, and greener.</p>
          </div>

          <div className="sr-terms__section">
            <h2>3. Your Account</h2>
            <p>When you sign up, use your real information — it helps everyone feel safe. Keep your login details private, and remember that everything that happens under your account is your responsibility.</p>
          </div>

          <div className="sr-terms__section">
            <h2>4. Be a Good Travel Buddy</h2>
            <p>This community works because people treat each other well. Be honest about your ride details and profile, be respectful to fellow members, follow traffic and safety laws, and never use the platform for anything shady or illegal.</p>
          </div>

          <div className="sr-terms__section">
            <h2>5. Ride Arrangements</h2>
            <p>When you arrange a ride, that's a deal between you and your travel buddy — we're just the middleman connecting you two. Make sure to confirm pickup spots, timing, and fare splits directly with each other before hitting the road.</p>
          </div>

          <div className="sr-terms__section">
            <h2>6. Stay Safe Out There</h2>
            <p>Your safety is in your hands. We can't be responsible for what happens during rides, but we strongly encourage you to check reviews and ratings before traveling with someone new. Trust your gut — if something feels off, don't go.</p>
          </div>

          <div className="sr-terms__section">
            <h2>7. Keeping the Community Clean</h2>
            <p>If someone breaks these guidelines, gets reported by multiple members, or acts in bad faith, we may need to suspend or remove their account. It's nothing personal — it's about keeping the community trustworthy for everyone.</p>
          </div>

          <div className="sr-terms__section">
            <h2>8. Guidelines May Evolve</h2>
            <p>As our community grows, these guidelines might get updated. We'll do our best to keep things fair and transparent. By continuing to use SastiRide, you're agreeing to the latest version.</p>
          </div>

          <div className="sr-terms__section">
            <h2>9. Get in Touch</h2>
            <p>Got questions, feedback, or ideas? We'd love to hear from you at <a href={`mailto:${process.env.REACT_APP_CONTACT_EMAIL}`}>{process.env.REACT_APP_CONTACT_EMAIL}</a>.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;
